module.exports = __webpack_public_path__ + "img/menu_icon.61c1ac7d.svg";